import { apiFetch } from 'utils/apiFetch'

export const serviceCenterNodeSwapReasonsGet = async () => {
  const swapReasons = await apiFetch({ url: '/service-center-node-swap-reasons', body: null })

  return swapReasons
}
